import {
  collection,
  query,
  orderBy,
  limit,
  startAfter,
  onSnapshot,
  where,
} from "firebase/firestore";
import { firestore } from "../../services/firebase";

const fetchFirestoreDataWithPagination = (
  collectionName,
  lastDoc,
  limitNumber,
  existingData,
  company,
  setData
) => {
  try {
    const dataCollection = collection(firestore, collectionName);

    let filters = [];

    if (company === "Asham") {
      filters.push(where("company", "in", ["Asham", "asham", "ASHAM"]));
    } else if (company === "external") {
      filters.push(where("company", "not-in", ["Asham", "asham", "ASHAM"]));
    }

    let firestoreQuery = query(
      dataCollection,
      ...filters,
      orderBy("createdAt", "desc")
    );

    if (lastDoc) {
      firestoreQuery = query(firestoreQuery, startAfter(lastDoc.createdAt));
    }

    if (limitNumber) {
      firestoreQuery = query(firestoreQuery, limit(limitNumber));
    }

    return onSnapshot(
      firestoreQuery,
      (querySnapshot) => {
        const newData = querySnapshot.docs.map((doc) => {
          const docData = { id: doc.id, ...doc.data() };
          return docData;
        });

        const mergedData = lastDoc ? [...existingData, ...newData] : newData;

        setData(mergedData);
      },
      (error) => {
        console.error("Firestore onSnapshot error:", error);
      }
    );
  } catch (error) {
    console.error("Firestore query setup error:", error);
  }
};

export default fetchFirestoreDataWithPagination;
